import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Theme, Ui } from '@silvertours/front-shared';
import { StaticLink } from '@silvertours/back-domain-page';
import { Link } from '../Link';

const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
  ${({ theme }) => theme.mq('md')} {
    display: flex;
    gap: 2.5rem;
  }
`;

const getLinkStyles = ({ theme }: { theme: Theme.Theme }) => css`
  font-weight: 600;
  font-size: 0.9375rem;
  font-family: ${theme.fontFamily.alternate};
  color: ${theme.color.white};
  text-decoration: none;
  text-align: left;

  &:focus-visible {
    border-radius: ${theme.borderRadius.md};
    outline: 0.125rem dashed ${theme.color.error};
    outline-offset: 0.25rem;
  }

  &:hover,
  &:active {
    text-decoration: underline;
  }

  ${theme.mq('md')} {
    font-size: 1rem;
  }
`;

const MaskedLink = styled(Ui.MaskedLink)`
  ${getLinkStyles}
`;

const Anchor = styled(Link)`
  ${getLinkStyles}
  text-decoration: none;
`;

type Props = {
  links: StaticLink[];
};

const LegalLinks = ({ links }: Props) => {
  if (links.length === 0) {
    return null;
  }

  return (
    <List>
      {links.map(({ text, target, href, title, masked }) => {
        const linkProps = {
          href,
          target,
          title,
        };

        return (
          <li key={`legal_${href}`}>
            {masked ? (
              <MaskedLink {...linkProps} body={text} />
            ) : (
              <Anchor
                {...linkProps}
                rel={target === '_blank' ? 'noopener noreferrer' : undefined}
              >
                {text}
              </Anchor>
            )}
          </li>
        );
      })}
    </List>
  );
};

export { LegalLinks };
